import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import Features from "./Features";
import ServiceSelector from "./ServiceSelector";
import api from "../../services/api";
import styles from "../../styles/public/reserve-page.module.css";

const ReservePage = ({ organization, onNext, bookingData }) => {
    const [features, setFeatures] = useState(() => []);
    const [services, setServices] = useState(() => []);
    const [selectedService, setSelectedService] = useState("");

    useEffect(() => {
        fetchFeatures();
        fetchServices();
    }, []);

    const fetchFeatures = async () => {
        try {
            const response = await api.get("/features/");
            setFeatures(response.data);
        } catch (error) {
            console.error("Error fetching features:", error.message);
        }
    };

    const fetchServices = async () => {
        try {
            const response = await api.get(
                `/current-services/`
            );
            
            setServices(response.data);
        } catch (error) {
            console.error("Error fetching services:", error);
        }
    };

    const handleContinue = (service) => {
        onNext({ service: service });
    };

    return (
        <Container>
            <div className={styles["section-title"]}>Choose your reservation</div>
            <ServiceSelector
                services={services}
                selectedService={selectedService}
                setSelectedService={setSelectedService}
                onServiceSelected={handleContinue}
            />
            
            <Features organization={organization} features={features} />


        </Container>
    );
};

export default ReservePage;
